/* 曹操傳・第 11 章：潼關・許褚護渡（建安十六年，211）
 * 史實：《三國志·許褚傳》「太祖將北渡，臨濟河，先渡兵，獨與褚及虎士百餘人留南岸斷後。超將步騎萬餘人，來奔太祖軍，矢下如雨。
 *       褚白太祖，賊來多，今兵渡已盡，宜去，乃扶太祖上船。賊戰急，軍爭濟，船重欲沒。……褚左手舉馬鞍蔽太祖。
 *       船工爲流矢所中死，褚右手並泝船，僅乃得渡。」《武帝紀》：「公自潼關北渡，未濟，超赴船急戰。校尉丁斐因放牛馬以餌賊，賊亂取牛馬，公乃得渡。」渡的是黃河。
 * 流程：1. 南岸斷後：操作許褚擋住馬超的騎兵，等船回來（曹操在碼頭邊）。
 *       2. 渡河：許褚划船，曹操在船上。岸上的箭先畫紅圈再射；船停著時許褚舉馬鞍替曹操擋箭，划船時就擋不住——看準箭雨的空檔划。
 *       丁斐放出牛馬後，一半的敵兵去搶，箭雨變稀。到北岸即勝利。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel, ally, boss, hero, troop, rout } from '../kit.ts';
import { DOCK, LANDING, CAMP } from '../maps/tongguan.ts';

const LV = 14, HOLD_T = 45;
const XL = troop('xiliang', '西涼騎', { armor: '#5a6a3a', sleeve: '#3a4a2a', cloth: '#3a4a2a', plume: '#a0b060' });
const FOE = { spec: XL, name: '西涼騎', hp: 480, maxHp: 480, atk: 28, ms: 270 };
const landOk = (x, y) => SG.gd(x, y, LANDING[0], LANDING[1]) < 420;

export default {
  id: 'caocao-11', map: 'tongguan', hero: 'xuchu',
  title: '第 11 章　潼關・許褚護渡', year: '建安十六年（211）',
  brief: {
    quote: [{ text: '太祖將北渡，臨濟河，先渡兵，獨與褚及虎士百餘人留南岸斷後。', src: '《三國志·魏書·許褚傳》' }],
    text: '馬超、韓遂起兵關西，曹操親征，與馬超夾關相持。曹操想從潼關北渡黃河、繞到敵後，先送大軍過河，自己帶許褚與虎士百餘人留在南岸斷後。',
    goals: ['南岸斷後，等船回來', '划船渡河，舉馬鞍替曹操擋箭', '到北岸'],
  },
  words: { ally: '虎士', foe: '西涼騎' },
  stars: [
    { text: '渡河時曹操沒中一箭', ok: (m) => !m.vars.caoHit },
    { text: '虎士折損不超過 3 人', ok: (m) => m.stats.lost <= 3 },
    { text: '40 秒內渡過河', ok: (m) => m.vars.crossT != null && m.vars.crossT < 40 },
  ],
  steps: [
    { // 1. 南岸斷後
      enter(m, w) {
        const me = w.player, V = m.vars;
        setLevel(w, me, LV);
        me.x = DOCK[0] + 200; me.y = DOCK[1] + 350;
        V.t0 = w.t;
        V.cao = ally(w, 'caocao', DOCK[0] - 80, DOCK[1] + 220, LV); V.cao.hold = [DOCK[0] - 80, DOCK[1] + 220];
        w.addBuff(V.cao, { id: '虎士護衛', t: HOLD_T + 2, taken: -0.5 }); // 碼頭邊有虎士圍著
        V.men = Array.from({ length: 8 }, (_, i) => { const u = m.recruit(me.x - 160 + (i % 4) * 90, me.y + 120 + Math.floor(i / 4) * 80, '虎士'); u.hp = u.maxHp = 600; u.atk = 28; m.join(u, me); return u; });
        V.ma = boss(w, hero('machao'), 6800, 3700, { name: '馬超', hp: 5000, atk: 46, armor: 9, ms: 250 });
        V.ma.home = [DOCK[0] + 200, DOCK[1] + 400];
        V.foes = [];
        for (let k = 0; k < 5; k++) m.after(2 + k * 8, () => { for (let i = 0; i < 4; i++) { const u = m.foe('huangjin', 6600 + (i % 3) * 80, 3500 + Math.floor(i / 3) * 140, FOE); u.home = [DOCK[0] + 150, DOCK[1] + 350]; V.foes.push(u); } });
        m.line('許褚', '主公先在碼頭等船，許褚在這裡擋住他們！');
        m.after(3, () => m.big('馬超來了！'));
        m.obj('hold', '');
      },
      tick(m, w) {
        const V = m.vars, left = HOLD_T - (w.t - V.t0);
        m.get('hold').text = `南岸斷後，等船回來（${Math.max(0, Math.ceil(left))} 秒）`;
        return left <= 0;
      },
    },
    { // 2. 扶太祖上船
      enter(m, w) {
        const me = w.player, V = m.vars;
        m.done('hold');
        m.card('褚白太祖，賊來多，今兵渡已盡，宜去，乃扶太祖上船。', '《許褚傳》');
        me.x = DOCK[0]; me.y = DOCK[1] - 60;
        V.cao.hold = null;
        V.b = m.boat(me, { x: DOCK[0], y: DOCK[1] - 60, sp: 150, crew: [V.cao], land: true, landOk, flag: '#3b5a99' });
        for (const u of m.alive(V.men)) { u.owner = null; u.home = [u.x, u.y]; } // 虎士留在南岸繼續擋
        V.t2 = w.t; V.caoHp = V.cao.hp; V.volT = 1.5;
        m.after(1.5, () => m.line('提示', '划船：右鍵點北岸。船停著時許褚舉馬鞍替曹操擋箭，划船時擋不住——看準箭雨的空檔再划。'));
        m.after(12, () => {
          m.card('校尉丁斐因放牛馬以餌賊，賊亂取牛馬，公乃得渡。', '《武帝紀》');
          V.cattle = true;
          rout(m, w, m.alive(V.foes).filter((_, i) => i % 2), [7400, 3900]);
        });
        m.mark('north', LANDING[0], LANDING[1] - 100, '北岸');
        m.obj('cross', '划船渡河，替曹操擋箭');
      },
      tick(m, w, dt) {
        const me = w.player, V = m.vars, b = V.b;
        // 箭雨：從南岸往船上射，先畫紅圈；船停著就是舉鞍擋住
        V.volT -= dt;
        if (V.volT <= 0 && me.boat) {
          V.volT = V.cattle ? 3.2 : 2.2;
          // 往船前頭射（預判划船的方向）：一直划會被射中，停下來就在圈裡、但有舉鞍擋著
          const g = b.goal || [b.x, b.y], gl = Math.hypot(g[0] - b.x, g[1] - b.y) || 1, lead = b.goal ? Math.min(gl, b.sp * 0.6) : 0;
          const tx = b.x + ((g[0] - b.x) / gl) * lead, ty = b.y + ((g[1] - b.y) / gl) * lead;
          m.warn({ x: tx, y: ty, r: 230, t: 1.2, col: '#ff5040', fn: (hit) => {
            const shield = b.still > 0.15;
            for (const u of hit) {
              if (u === V.cao && shield) { w.dmgEvents.push({ x: u.x, y: u.y - 70, text: '舉鞍', team: 0, src: me.id, tgt: u.id }); continue; }
              if (u.team === 0) { m.hurt(u, u === V.cao ? 140 : 70, 1); if (u === V.cao) V.caoHit = true; }
            }
            w.fx({ k: 'boom', x: tx, y: ty, r: 140, col: '#c86a3a' });
          } });
        }
        if (!V.cao.alive) { m.lose('曹操中箭'); return false; }
        return !me.boat;
      },
    },
    { // 3. 僅乃得渡
      enter(m, w) {
        const V = m.vars;
        V.crossT = w.t - V.t2;
        m.done('cross'); m.unmark('north');
        m.card('褚左手舉馬鞍蔽太祖。船工爲流矢所中死，褚右手並泝船，僅乃得渡。', '《許褚傳》');
        m.after(6, () => m.win());
      },
      tick() { return false; },
    },
  ],
  always(m, w) {
    const V = m.vars;
    if (!w.player.alive) { m.lose('許褚陣亡'); return; }
    if (V.cao && !V.cao.alive) { m.lose('曹操遇害'); return; }
    if (V.cao && !V.cao.boat && m.i === 0) { const c = V.cao, I = c.input, near = w.units.find((t) => w.isEnemy(c, t) && SG.gd(t.x, t.y, c.x, c.y) < 200); if (near) { I.target = near; I.engage = true; } else { I.target = null; if (SG.gd(c.x, c.y, c.hold[0], c.hold[1]) > 40) I.moveTo = c.hold.slice(); } }
  },
};
